// export const allSkills = [
//   // 'あ行のスキル',
//   'アイテム使用強化',
//   '泡沫の舞',
//   '炎鱗の恩恵',
//   '鬼火纏',
//   // 'か行のスキル',
//   'ガード強化',
//   'ガード性能',
//   '会心撃【属性】',
//   '回避距離UP',
//   '回避性能',
//   '回復速度',
//   '翔蟲使い',
//   '火事場力',
//   '滑走強化',
//   '霞皮の恩恵',
//   '雷属性攻撃強化',
//   '雷耐性',
//   '貫通弾・貫通矢強化',
//   '気絶耐性',
//   'キノコ大好き',
//   '逆襲',
//   '強化持続',
//   'KO術',
//   '広域化',
//   '幸運',
//   '鋼殻の恩恵',
//   '攻撃',
//   '剛刃研磨',
//   '高速変形',
//   '氷属性攻撃強化',
//   '氷耐性',
//   '渾身',
//   // 'さ行のスキル',
//   '逆恨み',
//   '散弾・拡散矢強化',
//   '死中に活',
//   '弱点特効',
//   'ジャンプ鉄人',
//   '集中',
//   '植生学',
//   '心眼',
//   '睡眠属性強化',
//   '睡眠耐性',
//   'スタミナ急速回復',
//   'スタミナ奪取',
//   '精霊の加護',
//   '攻めの守勢',
//   '装填拡張',
//   '装填速度',
//   '速射強化',
//   '属性やられ耐性',
//   // 'た行のスキル',
//   '体術',
//   '耐震',
//   '体力回復量UP',
//   '匠',
//   '達人芸',
//   '弾丸節約',
//   '弾導強化',
//   '力の解放',
//   '地質学',
//   '超会心',
//   '挑戦者',
//   '通常弾・連射矢強化',
//   '泥雪耐性',
//   '砥石使用高速化',
//   '特殊射撃強化',
//   '毒属性強化',
//   '毒耐性',
//   '飛び込み',
//   '鈍器使い',
//   // 'な行のスキル',
//   '納刀術',
//   '乗り名人',
//   // 'は行のスキル',
//   '破壊王',
//   '剥ぎ取り鉄人',
//   '剥ぎ取り名人',
//   '爆破属性強化',
//   '爆破やられ耐性',
//   '抜刀術【力】',
//   '抜刀術【技】',
//   '早食い',
//   '腹減り耐性',
//   '反動軽減',
//   '火属性攻撃強化',
//   '火耐性',
//   'ひるみ軽減',
//   '風圧耐性',
//   '風紋の一致',
//   '笛吹き名人',
//   '不屈',
//   'フルチャージ',
//   'ブレ抑制',
//   '壁面移動',
//   '防御',
//   '砲術',
//   '砲弾装填',
//   '捕獲名人',
//   'ボマー',
//   // 'ま行のスキル',
//   '麻痺属性強化',
//   '麻痺耐性',
//   '満足感',
//   '見切り',
//   '水属性攻撃強化',
//   '水耐性',
//   '耳栓',
//   // 'や行のスキル',
//   '弓溜め段階解放',
//   '陽動',
//   // 'ら行のスキル',
//   '雷紋の一致',
//   'ランナー',
//   '龍属性攻撃強化',
//   '龍耐性',
//   // 'わ行のスキル',
//   '業物',
// ]


export const allSkillDetails = [
  // 'あ行のスキル',
  { name: 'アイテム使用強化',   hiragana: 'あいてむしようきょうか',           englishCharacters: 'aitemusiyoukyouka'            },
  { name: '泡沫の舞',           hiragana: 'うたかたのまい',                   englishCharacters: 'utakatanomai'                 },
  { name: '炎鱗の恩恵',         hiragana: 'えんりんのおんけい',               englishCharacters: 'enrinnoonkei'                 },
  { name: '鬼火纏',             hiragana: 'おにびまとい',                     englishCharacters: 'onibimatoi'                   },
  // 'か行のスキル',
  { name: 'ガード強化',         hiragana: 'がーどきょうか',                   englishCharacters: 'ga-dokyouka'                  },
  { name: 'ガード性能',         hiragana: 'がーどせいのう',                   englishCharacters: 'ga-doseinou'                  },
  { name: '会心撃【属性】',     hiragana: 'かいしんげきぞくせい',             englishCharacters: 'kaisingekizokusei'            },
  { name: '回避距離UP',         hiragana: 'かいひきょりあっぷ',               englishcharacters: 'kaihikyoriappu'               },
  { name: '回避性能',           hiragana: 'かいひせいのう',                   englishCharacters: 'kaihiseinou'                  },
  { name: '回復速度',           hiragana: 'かいふくそくど',                   englishCharacters: 'kaihukusokudo'                },
  { name: '翔蟲使い',           hiragana: 'かけりむしつかい',                 englishCharacters: 'kakerimusitukai'              },
  { name: '火事場力',           hiragana: 'かじばりょく',                     englishCharacters: 'kajibaryoku'                  },
  { name: '滑走強化',           hiragana: 'かっそうきょうか',                 englishCharacters: 'kassoukyouka'                 },
  { name: '霞皮の恩恵',         hiragana: 'かすみがわのおんけい',             englishCharacters: 'kasumigawanoonkei'            },
  { name: '雷属性攻撃強化',     hiragana: 'かみなりぞくせいこうげききょうか', englishCharacters: 'kaminarizokuseikougekikyouka' },
  { name: '雷耐性',             hiragana: 'かみなりたいせい',                 englishCharacters: 'kaminaritaisei'               },
  { name: '貫通弾・貫通矢強化', hiragana: 'かんつうだんかんつうやきょうか',   englishCharacters: 'kantuudankantuuyakyouka'      },
  { name: '気絶耐性',           hiragana: 'きぜつたいせい',                   englishCharacters: 'kizetutaisei'                 },
  { name: 'キノコ大好き',       hiragana: 'きのこだいすき',                   englishCharacters: 'kinokodaisuki'                },
  { name: '逆襲',               hiragana: 'ぎゃくしゅう',                     englishCharacters: 'gyakusyuu'                    },
  { name: '強化持続',           hiragana: 'きょうかじぞく',                   englishCharacters: 'kyoukajizoku'                 },
  { name: 'KO術',               hiragana: 'けーおーじゅつ',                   englishcharacters: 'ke-o-jutu'                    },
  { name: '広域化',             hiragana: 'こういきか',                       englishCharacters: 'kouikika'                     },
  { name: '幸運',               hiragana: 'こううん',                         englishCharacters: 'kouun'                        },
  { name: '鋼殻の恩恵',         hiragana: 'こうかくのおんけい',               englishCharacters: 'koukakunoonkei'               },
  { name: '攻撃',               hiragana: 'こうげき',                         englishCharacters: 'kougeki'                      },
  { name: '剛刃研磨',           hiragana: 'ごうじんけんま',                   englishCharacters: 'goujinkenma'                  },
  { name: '高速変形',           hiragana: 'こうそくへんけい',                 englishCharacters: 'kousokuhenkei'                },
  { name: '氷属性攻撃強化',     hiragana: 'こおりぞくせいきょうか',           englishCharacters: 'koorizokuseikyouka'           },
  { name: '氷耐性',             hiragana: 'こおりたいせい',                   englishCharacters: 'kooritaisei'                  },
  { name: '渾身',               hiragana: 'こんしん',                         englishCharacters: 'konsin'                       },
  // 'さ行のスキル',
  { name: '逆恨み',             hiragana: 'さかうらみ',                       englishCharacters: 'sakaurami'                    },
  { name: '散弾・拡散矢強化',   hiragana: 'さんだんかんつうやきょうか',       englishCharacters: 'sandankantuuyakyouka'         },
  { name: '死中に活',           hiragana: 'しちゅうにかつ',                   englishCharacters: 'sityuunikatu'                 },
  { name: '弱点特効',           hiragana: 'じゃくてんとっこう',               englishCharacters: 'jakutentokkou'                },
  { name: 'ジャンプ鉄人',       hiragana: 'じゃんぷてつじん',                 englishCharacters: 'janputetujin'                 },
  { name: '集中',               hiragana: 'しゅうちゅう',                     englishCharacters: 'syuutyuu'                     },
  { name: '植生学',             hiragana: 'しょくせいがく',                   englishCharacters: 'syokuseigaku'                 },
  { name: '心眼',               hiragana: 'しんがん',                         englishCharacters: 'singan'                       },
  { name: '睡眠属性強化',       hiragana: 'すいみんぞくせいきょうか',         englishCharacters: 'suiminzokuseikyouka'          },
  { name: '睡眠耐性',           hiragana: 'すいみんたいせい',                 englishCharacters: 'suimintaisei'                 },
  { name: 'スタミナ急速回復',   hiragana: 'すたみなきゅうそくかいふく',       englishCharacters: 'sutaminakyuusokukaihuku'      },
  { name: 'スタミナ奪取',       hiragana: 'すたみなだっしゅ',                 englishCharacters: 'sutaminadassyu'               },
  { name: '精霊の加護',         hiragana: 'せいれいのかご',                   englishCharacters: 'seireinokago'                 },
  { name: '攻めの守勢',         hiragana: 'せめのしゅせい',                   englishCharacters: 'semenosyusei'                 },
  { name: '装填拡張',           hiragana: 'そうてんかくちょう',               englishCharacters: 'soutenkakutyou'               },
  { name: '装填速度',           hiragana: 'そうてんそくど',                   englishCharacters: 'soutensokudo'                 },
  { name: '速射強化',           hiragana: 'そくしゃきょうか',                 englishCharacters: 'sokusyakyouka'                },
  { name: '属性やられ耐性',     hiragana: 'ぞくせいやられたいせい',           englishCharacters: 'zokuseiyararetaisei'          },
  // 'た行のスキル',
  { name: '体術',               hiragana: 'たいじゅつ',                       englishCharacters: 'taijutu'                      },
  { name: '耐震',               hiragana: 'たいしん',                         englishCharacters: 'taisin'                       },
  { name: '体力回復量UP',       hiragana: 'たいりょくかいふくりょうあっぷ',   englishcharacters: 'tairyokukaihukuryouappu'      },
  { name: '匠',                 hiragana: 'たくみ',                           englishCharacters: 'takumi'                       },
  { name: '達人芸',             hiragana: 'たつじんげい',                     englishCharacters: 'tatujingei'                   },
  { name: '弾丸節約',           hiragana: 'だんがんせつやく',                 englishCharacters: 'dangansetuyaku'               },
  { name: '弾導強化',           hiragana: 'だんどうきょうか',                 englishCharacters: 'dandoukyouka'                 },
  { name: '力の解放',           hiragana: 'ちからのかいほう',                 englishCharacters: 'tikaranokaihou'               },
  { name: '地質学',             hiragana: 'ちしつがく',                       englishCharacters: 'tisitugaku'                   },
  { name: '超会心',             hiragana: 'ちょうかいしん',                   englishCharacters: 'tyoukaisin'                   },
  { name: '挑戦者',             hiragana: 'ちょうせんしゃ',                   englishCharacters: 'tyousensya'                   },
  { name: '通常弾・連射矢強化', hiragana: 'つうじょうだんそくしゃやきょうか', englishCharacters: 'tuujoudansokusyayakyouka'     },
  { name: '泥雪耐性',           hiragana: 'でいせつたいせい',                 englishCharacters: 'deisetutaisei'                },
  { name: '砥石使用高速化',     hiragana: 'といししようこうそくか',           englishCharacters: 'toisisiyoukousokuka'          },
  { name: '特殊射撃強化',       hiragana: 'とくしゅしゃげききょうか',         englishCharacters: 'tokusyusyagekikyouka'         },
  { name: '毒属性強化',         hiragana: 'どくぞくせいきょうか',             englishCharacters: 'dokuzokuseikyouka'            },
  { name: '毒耐性',             hiragana: 'どくたいせい',                     englishCharacters: 'dokutaisei'                   },
  { name: '飛び込み',           hiragana: 'とびこみ',                         englishCharacters: 'tobikomi'                     },
  { name: '鈍器使い',           hiragana: 'どんきつかい',                     englishCharacters: 'donkitukai'                   },
  // 'な行のスキル',
  { name: '納刀術',             hiragana: 'のうとうじゅつ',                   englishCharacters: 'noutoujutu'                   },
  { name: '乗り名人',           hiragana: 'のりめいじん',                     englishCharacters: 'norimeijin'                   },
  // 'は行のスキル',
  { name: '破壊王',             hiragana: 'はかいおう',                       englishCharacters: 'hakaiou'                      },
  { name: '剥ぎ取り鉄人',       hiragana: 'はぎとりてつじん',                 englishCharacters: 'hagitoritetujin'              },
  { name: '剥ぎ取り名人',       hiragana: 'はぎとりめいじん',                 englishCharacters: 'hagitorimeijin'               },
  { name: '爆破属性強化',       hiragana: 'ばくはぞくせいきょうか',           englishCharacters: 'bakuhazokuseikyouka'          },
  { name: '爆破やられ耐性',     hiragana: 'ばくはやられたいせい',             englishCharacters: 'bakuhayararetaisei'           },
  { name: '抜刀術【力】',       hiragana: 'ばっとうじゅつちから',             englishCharacters: 'battoujututikara'             },
  { name: '抜刀術【技】',       hiragana: 'ばっとうじゅつわざ',               englishCharacters: 'battoujutuwaza'               },
  { name: '早食い',             hiragana: 'はやぐい',                         englishCharacters: 'hayagui'                      },
  { name: '腹減り耐性',         hiragana: 'はらへりたいせい',                 englishCharacters: 'haraheritaisei'               },
  { name: '反動軽減',           hiragana: 'はんどうけいげん',                 englishCharacters: 'handoukeigen'                 },
  { name: '火属性攻撃強化',     hiragana: 'ひぞくせいこうげききょうか',       englishCharacters: 'hizokuseikougekikyouka'       },
  { name: '火耐性',             hiragana: 'ひたいせい',                       englishCharacters: 'hitaisei'                     },
  { name: 'ひるみ軽減',         hiragana: 'ひるみけいげん',                   englishCharacters: 'hirumikeigen'                 },
  { name: '風圧耐性',           hiragana: 'ふうあつたいせい',                 englishCharacters: 'huuatutaisei'                 },
  { name: '風紋の一致',         hiragana: 'ふうもんのいっち',                 englishCharacters: 'huumonnoitti'                 },
  { name: '笛吹き名人',         hiragana: 'ふえふきめいじん',                 englishCharacters: 'huehukimeijin'                },
  { name: '不屈',               hiragana: 'ふくつ',                           englishCharacters: 'hukutu'                       },
  { name: 'フルチャージ',       hiragana: 'ふるちゃーじ',                     englishCharacters: 'hurutya-ji'                   },
  { name: 'ブレ抑制',           hiragana: 'ぶれよくせい',                     englishCharacters: 'bureyokusei'                  },
  { name: '壁面移動',           hiragana: 'へきめんいどう',                   englishCharacters: 'hekimenidou'                  },
  { name: '防御',               hiragana: 'ぼうぎょ',                         englishCharacters: 'bougyo'                       },
  { name: '砲術',               hiragana: 'ほうじゅつ',                       englishCharacters: 'houjutu'                      },
  { name: '砲弾装填',           hiragana: 'ほうだんそうてん',                 englishCharacters: 'houdansouten'                 },
  { name: '捕獲名人',           hiragana: 'ほかくめいじん',                   englishCharacters: 'hokakumeijin'                 },
  { name: 'ボマー',             hiragana: 'ぼまー',                           englishCharacters: 'boma-'                        },
  // 'ま行のスキル',
  { name: '麻痺属性強化',       hiragana: 'まひぞくせいきょうか',             englishCharacters: 'mahizokuseikyouka'            },
  { name: '麻痺耐性',           hiragana: 'まひたいせい',                     englishCharacters: 'mahitaisei'                   },
  { name: '満足感',             hiragana: 'まんぞくかん',                     englishCharacters: 'manzokukan'                   },
  { name: '見切り',             hiragana: 'みきり',                           englishCharacters: 'mikiri'                       },
  { name: '水属性攻撃強化',     hiragana: 'みずぞくせいこうげききょうか',     englishCharacters: 'mizuzokuseikougekikyouka'     },
  { name: '水耐性',             hiragana: 'みずたいせい',                     englishCharacters: 'mizutaisei'                   },
  { name: '耳栓',               hiragana: 'みみせん',                         englishCharacters: 'mimisen'                      },
  // 'や行のスキル',
  { name: '弓溜め段階解放',     hiragana: 'ゆみためだんかいかいほう',         englishCharacters: 'yumitamedankaikaihou'         },
  { name: '陽動',               hiragana: 'ようどう',                         englishCharacters: 'youdou'                       },
  // 'ら行のスキル',
  { name: '雷紋の一致',         hiragana: 'らいもんのいっち',                 englishCharacters: 'raimonnoitti'                 },
  { name: 'ランナー',           hiragana: 'らんなー',                         englishCharacters: 'ranna-'                       },
  { name: '龍属性攻撃強化',     hiragana: 'りゅうぞくせいこうげききょうか',   englishCharacters: 'ryuuzokuseikougekikyouka'     },
  { name: '龍耐性',             hiragana: 'りゅうたいせい',                   englishCharacters: 'ryuutaisei'                   },
  // 'わ行のスキル',
  { name: '業物',               hiragana: 'わざもの',                         englishCharacters: 'wazamono'                     },
]



export const getAllSkillNames = () => allSkillDetails.map(i => i.name)
